module.exports = __webpack_public_path__ + "img/account-choose-icon.57348f5c.svg";